import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import s from './UserSymbol.scss';
function useUserSymbolTranslation(userType) {
    var t = useTranslation().t;
    switch (userType) {
        case 'admin':
            return t('userSymbolsPopup.symbols.admin.title');
        case 'banned':
            return undefined;
        case 'beta':
            return t('userSymbolsPopup.symbols.beta.title');
        case 'buyer':
            return undefined;
        case 'group':
            return t('userSymbol.a11y.group.title');
        case 'hell':
            return t('userSymbolsPopup.symbols.hell.title');
        case 'hell-beta':
            return t('userSymbolsPopup.symbols.hell-beta.title');
        case 'premium':
            return t('userSymbolsPopup.symbols.premium.title');
        case 'regular':
            return undefined;
        case 'senior':
            return t('userSymbolsPopup.symbols.senior.title');
        case 'super':
            return t('userSymbol.a11y.superGroup.title');
        case 'volunteer':
            return t('userSymbolsPopup.symbols.volunteer.title');
        default:
            return undefined;
    }
}
export var UserSymbol = function (_a) {
    var userType = _a.userType, className = _a.className, onClick = _a.onClick, ariaHidden = _a["aria-hidden"];
    var label = useUserSymbolTranslation(userType);
    return (React.createElement("span", { className: classnames(s['symbol'], s[userType], className), style: onClick && { cursor: 'pointer' }, onClick: onClick, "aria-label": label, "aria-hidden": ariaHidden }));
};
UserSymbol.displayName = 'UserSymbol';
export default UserSymbol;
//# sourceMappingURL=UserSymbol.js.map